<template>
    <div class="page-container">
        <tabs :active-tab="activeTab"
              @changed="onTabChange">
            <tab title="Rosters">
                <rosters-list></rosters-list>
            </tab>
            <tab title="Waitlist"
                 v-if="hasAccess(['view', 'waitlist.camps'])">
                <wait-list></wait-list>
            </tab>
            <tab title="Attendance">
                <attendance-list></attendance-list>
            </tab>
        </tabs>
    </div>
</template>

<script>
    import { mapActions, mapMutations } from 'vuex';
    import * as Routes from '@/router/routes';
    import * as Mutations from '@/store/modules/camp-page/mutations';
    import * as MutationsPage from '@/store/modules/page/mutations';
    import { TabRouteChangeMixin } from '@/mixins/TabRouteChangeMixin';
    import { PermissionMixin } from '@/mixins/PermissionMixin';

    export default {
        name: 'ChildrenPage',
        components: {
            AttendanceList: () => import('./CampAttendanceList'),
            WaitList: () => import('./WaitList'),
            RostersList: () => import('./RostersList'),
            Tabs: () => import('@/components/controls/Tabs'),
            Tab: () => import('@/components/controls/Tab')
        },
        props: {
            tab: String,
            default: Routes.CAMP_ROSTERS
        },
        mixins: [TabRouteChangeMixin, PermissionMixin()],
        methods: {
            ...mapActions(['fetchCampPricingNameById', 'removeStats']),
            ...mapMutations({
                clearCampPricingName: Mutations.CLEAR_CAMP_PRICING_NAME,
                removeAllFilters: MutationsPage.REMOVE_ALL_FILTERS
            }),
            onTabChange(tab) {
                switch (tab) {
                    case 'Rosters':
                        this.$router.push({ name: Routes.CAMP_ROSTERS });
                        break;
                    case 'Waitlist':
                        this.$router.push({ name: Routes.CAMP_WAIT_LIST });
                        break;
                    case 'Attendance':
                        this.$router.push({ name: Routes.CAMP_ATTENDANCE });
                        break;
                }
            }
        },
        created() {
            const { id } = this.$route.params;
            this.fetchCampPricingNameById(id);
        },
        beforeDestroy() {
            this.clearCampPricingName();
            this.removeStats();
        },
        beforeRouteLeave(to, from, next) {
            !to.path.includes('camps') && this.removeAllFilters();
            next()
        }
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/main/pages/camps/camp-details/CampDetailsPage.vue